<template>
  <div class="flex flex-col gap-y-4">
    <PrescriptionRenewalStepTitle title="Identifiez-vous" back @back="emits('previous-step')" />
    <div class="step-card">
      <p>Sélectionnez votre code vendeur</p>
      <v-chip-group
        v-model="selected"
        selected-class="bg-apodis text-white"
        column
      >
        <v-chip
          v-for="(code, index) in filteredOperatorCodes"
          :key="index"
          filter
          :text="itemLabel(code)"
          :value="code"
        />
      </v-chip-group>
    </div>
    <div class="flex flex-row justify-end">
      <base-button
        primary
        :disabled="!selected"
        @click="emits('next-step')"
      >
        Continuer
      </base-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseButton from '@/core/components/base/BaseButton.vue';
import PrescriptionRenewalStepTitle from "@/prescription/components/PrescriptionRenewalStepTitle.vue";
import LegacyAccess from "@/core/interfaces/Access";
import {computed} from "vue";

const props = defineProps<{
    operatorCodes: string[];
    teamAccess: LegacyAccess[];
}>();

const selected = defineModel("selected", {required: true, type: String});

const filteredOperatorCodes = computed(() => {
    return props.operatorCodes.filter((code) => !!code);
});

/**
 * Add the user name next to the label if available.
 */
const itemLabel = (code: string): string => {
    const access = props.teamAccess?.find((access) => access.operatorCode === code);

    if (!access) {
        return code;
    }

    return `${access.user.name} (${code})`;
};

const emits = defineEmits(['next-step', 'previous-step']);
</script>
